const DOWNLOAD_ICON = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.5 14.5672V16H0.5V14.5672H15.5ZM8.70312 0V10.695L12.5099 6.92164L12.9997 7.43563L13.4904 7.94869L8 13.3918L2.50958 7.94869L3.00031 7.43563L3.49011 6.92164L7.29688 10.695V0H8.70312Z" fill="currentColor"/></svg>'

export default function docModal() {
    const modal = document.querySelector('[data-doc-modal]')
    const root = document.querySelector('[data-docs-product]')
    if (!modal || !root) return

    const productId = root.dataset.docsProduct
    const storageKey = `lae-docs-unlocked-${productId}`
    const titleEl = modal.querySelector('[data-doc-modal-title]')
    const formWrap = modal.querySelector('.doc-modal__form')
    const successEl = modal.querySelector('[data-doc-modal-success]')

    const open = (title, pdfName) => {
        if (titleEl) titleEl.textContent = title.toUpperCase()
        const pdfField = modal.querySelector('[name="pdf_name"]')
        if (pdfField) pdfField.value = pdfName || ''
        modal.classList.add('is-open')
        modal.removeAttribute('hidden')
        document.body.classList.add('doc-modal-open')
    }

    const close = () => {
        modal.classList.remove('is-open')
        modal.setAttribute('hidden', '')
        document.body.classList.remove('doc-modal-open')
    }

    const unlock = () => {
        root.querySelectorAll('.file-item.is-locked').forEach((item) => {
            item.classList.remove('is-locked')
            const btn = item.querySelector('[data-doc-modal-open]')
            if (btn && item.querySelector('.file-item__langs-pop')) {
                const toggle = document.createElement('button')
                toggle.type = 'button'
                toggle.className = 'file-item__action'
                toggle.dataset.langToggle = ''
                toggle.setAttribute('aria-expanded', 'false')
                toggle.setAttribute('aria-label', 'Download')
                toggle.innerHTML = DOWNLOAD_ICON
                btn.replaceWith(toggle)
            } else if (btn?.dataset.directUrl) {
                const a = document.createElement('a')
                a.className = 'file-item__action'
                a.href = btn.dataset.directUrl
                a.target = '_blank'
                a.rel = 'noopener noreferrer'
                a.setAttribute('aria-label', 'Download')
                a.innerHTML = DOWNLOAD_ICON
                btn.replaceWith(a)
            }
            item.querySelectorAll('[data-file-url]').forEach((el) => {
                const a = document.createElement('a')
                a.className = 'file-item__lang'
                a.href = el.dataset.fileUrl
                a.target = '_blank'
                a.rel = 'noopener noreferrer'
                a.textContent = el.textContent
                el.replaceWith(a)
            })
        })
    }

    const onSuccess = () => {
        if (formWrap) formWrap.hidden = true
        if (successEl) successEl.hidden = false
        localStorage.setItem(storageKey, '1')
        unlock()
    }

    if (localStorage.getItem(storageKey)) unlock()

    const closePickers = () => {
        root.querySelectorAll('.file-item__picker.is-open').forEach((picker) => {
            picker.classList.remove('is-open')
            picker.querySelector('[data-lang-toggle]')?.setAttribute('aria-expanded', 'false')
        })
    }

    root.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-lang-toggle]')
        if (toggle && root.contains(toggle)) {
            const picker = toggle.closest('.file-item__picker')
            const willOpen = !picker.classList.contains('is-open')
            closePickers()
            if (willOpen) {
                const pop = picker.querySelector('.file-item__langs-pop')
                if (pop) picker.style.setProperty('--pop-w', `${pop.offsetWidth}px`)
                picker.classList.add('is-open')
                toggle.setAttribute('aria-expanded', 'true')
            }
            return
        }
        const modalBtn = e.target.closest('[data-doc-modal-open]')
        if (modalBtn && root.contains(modalBtn)) open(modalBtn.dataset.docTitle || '', modalBtn.dataset.docName || '')
    })
    document.addEventListener('click', (e) => {
        if (e.target.closest('.file-item__lang')) {
            closePickers()
            return
        }
        if (!e.target.closest('.file-item__picker')) closePickers()
    })
    modal.addEventListener('click', (e) => {
        if (e.target === modal) close()
    })
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return
        closePickers()
        if (modal.classList.contains('is-open')) close()
    })

    if (window.jQuery) {
        window.jQuery(document).on('fluentform_submission_success', onSuccess)
    }
    document.addEventListener('fluentform_submission_success', onSuccess)
}
